import { render, staticRenderFns } from "./cis_verification.vue?vue&type=template&id=961d09ea&scoped=true"
import script from "./cis_verification.vue?vue&type=script&lang=js"
export * from "./cis_verification.vue?vue&type=script&lang=js"
import style0 from "./cis_verification.vue?vue&type=style&index=0&id=961d09ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d09ea",
  null
  
)

export default component.exports